module.exports = __webpack_public_path__ + "static/18-57c7531045a403b374c64ce2f9b3b4f6.jpg";